._ProgramOnboardingHTML_17zdn_1 {
  padding-top: 20px;
}